<div class="row offer-item m-2 mt-2" (click)="goToOfferDetails(offer.id)">
  <div class="left-ellipse"></div>
  <div class="right-ellipse"></div>

  <div
    fs24
    no-padding
    class=" coll col-2 offer-left-column {{ offer?.type }} {{
      offer.plus ? 'plus' : ''
    }}"
  >
    <div class="offer_type_nm">{{ offer.plus ? "Plus" : offer?.type }}</div>
  </div>
  <div no-padding class="coll col offer-right-column">
    <div
      class="row offer-top-right-row"
      [style.background-image]="'url(' + offer?.cover + ')'"
      justify-content-between
    >
      <div class="coll col-4 brand-logo" align-self-center no-padding>
        <div class="white-box">
          <img *ngIf="offer?.logo" [src]="offer?.logo" alt="brand logo" />
        </div>
      </div>
      <!-- <div offset-5 class="coll col-3 py-2 offer-limit-and-wishlist">
        <div class="row offer-limit" justify-content-end>
          <span class="bottom-badge badge">
            <span fs14 white>{{ offer.plus ? offer.plus_claimed_times : offer.claimed_times }}</span>
          </span>
        </div>
        <div class="row offer-wishlist" justify-content-end>
            <ion-icon (click)="toggleWishlist($event, offer?.id, offer?.addedToFavourites)" [name]="offer?.addedToFavourites?'md-star':'md-star-outline'"></ion-icon>
          </div>
      </div> -->
    </div>
    <div class="row offer-bottom-right-row" align-items-center>
      <div fs16 class="coll col offer-title">
        {{ offer?.name }}
      </div>
      <div col-auto class="coll col offer-button-and-expiry" margin-right>
        <!-- <div class="offer-button" justify-content-center>
                    <button mat-raised-button class="bbbtn" type="button">{{'GET IT NOW' | translate}}</button>
                </div> -->
        <div class="offer-expiry" justify-content-end align-items-center>
          <p fs10>
            <span class="spn1">{{ "Valid Till" | translate }}</span
            ><span fs12>{{ offer?.expiry_date }}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
